import { render } from "./App.vue?vue&type=template&id=5996dd9c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5996dd9c&lang=css"

import exportComponent from "D:\\20231109nkGg7QhS(1)\\20231109nkGg7QhS\\vueweb\\vue-antd-tool-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__